import type { ReactElement } from 'react'

import { InfoTable } from './Table'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
import { BulletedList } from '@/components/layouts/Ir/BulletedList'
import { BHeading } from '@/components/layouts/Ir/Heading'

export const InfoPage = () => {
  return (
    <Layout>
      <SectionTitle
        titleText="Basic Information"
        subTitleText="株式基本情報"
        color="normal"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <InfoTable />
      <Spacer h={{ sp: 50, pc: 80 }} />
      <BHeading>ご注意事項</BHeading>
      <BulletedList listStyle="decimal">
        <li>
          住所、氏名などの変更、配当金受領方法の指定、単元未満株式の買取請求などの株式の諸手続につきましては、お取引のある証券会社にお問い合わせください。
        </li>
        <li>
          特別口座に記録された株式に関する各種お手続きにつきましては、三菱UFJ信託銀行株式会社が口座管理機関となっておりますので、上記特別口座の口座管理機関（三菱UFJ信託銀行株式会社）にお問い合わせください。
        </li>
      </BulletedList>
    </Layout>
  )
}

InfoPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主、投資家向け情報', path: '/ir' },
    { name: '株式情報', path: '/ir/stock' },
    { name: '株式基本情報', path: '' },
  ]

  return (
    <>
      <Head
        title="株式基本情報"
        description="トライアルホールディングスの株式に関する基本情報について掲載しています。"
        ogp={{ url: 'ir/stock/info' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
